//
// qrUrl
//
import config from './config';

const qrUrl = (qrid) => (`${config.anon.www.corporate.home}q/${qrid}`);

export default qrUrl;
